module.exports = __webpack_public_path__ + "media/application/images/icons/clipboard_white-ce3981fc15a9c517bf1f461397abe739.svg";